<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-brand">
        <div class="footer-brand-title">
          <img src="@/assets/logo.webp" alt="GB WhatsApp logo" width="36" height="36">
          <strong>AndroidWaves</strong>
        </div>
        <p>
          This website is an independent resource and is not affiliated with, endorsed by, or sponsored by WhatsApp LLC or Meta Platforms, Inc.
        </p>
      </div>
      <nav class="footer-links" aria-label="Legal">
        <router-link :to="{ name: 'about-us' }">About Us</router-link>
        <router-link :to="{ name: 'contact' }">Contact</router-link>
        <router-link :to="{ name: 'privacy-policy' }">Privacy Policy</router-link>
        <router-link :to="{ name: 'terms-and-conditions' }">Terms</router-link>
        <router-link :to="{ name: 'disclaimer' }">Disclaimer</router-link>
        <router-link :to="{ name: 'dmca' }">DMCA</router-link>
        <router-link :to="{ name: 'cookie-policy' }">Cookie Policy</router-link>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid #d8e5dd;
  background: #fff;
  color: #33443d;
  padding: 14px 0 16px;
}

.footer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: min(1180px, calc(100% - 40px));
  margin: 0 auto;
  text-align: center;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-brand-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.footer-brand-title img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 6px;
}

.footer-brand-title strong {
  margin-bottom: 0;
  color: #18231f;
  font-size: 16px;
  line-height: 1.2;
}

p {
  max-width: 760px;
  margin: 0;
  color: #64746d;
  font-size: 13px;
  line-height: 1.5;
}

p a {
  color: #0b7a5a;
  font-weight: 600;
  text-decoration: none;
}

p a:hover {
  text-decoration: underline;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
}

.footer-links a {
  color: #0b7a5a;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: none;
  white-space: nowrap;
}

.footer-links a:not(:last-child)::after {
  content: '|';
  display: inline-block;
  margin: 0 8px;
  color: #b4c0ba;
  font-weight: 400;
}

.footer-links a:hover {
  text-decoration: underline;
}
</style>
